module.exports = __webpack_public_path__ + "static/avanti-083ebf91d370ad702e0bdbd97bc3bfee.jpg";